import { render, staticRenderFns } from "./ActiveGift.vue?vue&type=template&id=78d59be9&"
import script from "./ActiveGift.vue?vue&type=script&lang=js&"
export * from "./ActiveGift.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports